import { isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';
import { SvgIcon } from '../../Icon';
import SearchInput from '../../Form/SearchInput';
import { ColumnFilterConfig } from './types';
import * as ColumnFilterWidgetUI from './ColumnFilterWidgetUI';
import { theme } from '../../../styles/theme';
import ThinDivider from '../../ThinDivider';

interface IProps {
  filterConfig: ColumnFilterConfig | null;
  columnValues: (string | number)[];
  onChange: (value: string | number) => void;
}

const FilterValues = ({ filterConfig, columnValues, onChange }: IProps) => {
  const [searchTerm, setSearchTerm] = useState('');

  const data = useMemo(() => {
    if (isEmpty(searchTerm)) {
      return columnValues;
    }
    return columnValues.filter((columnValue) => {
      return columnValue
        .toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    });
  }, [columnValues, searchTerm]);

  return (
    <ColumnFilterWidgetUI.Container>
      <SearchInput value={searchTerm} onChange={setSearchTerm} />
      <ThinDivider layout="horizontal" size="full" />
      <ColumnFilterWidgetUI.List>
        {data.map((columnValue, i) => {
          const isActive = filterConfig?.values?.includes(columnValue);
          return (
            <ColumnFilterWidgetUI.ListItem
              key={`list-item-${i}`}
              $isActive={!!isActive}
              onClick={() => onChange(columnValue)}
            >
              {isActive ? (
                <SvgIcon
                  name="checkmark"
                  height={12}
                  width={12}
                  customFill={theme.colors.mainBlue}
                />
              ) : (
                <ColumnFilterWidgetUI.Space />
              )}
              <ColumnFilterWidgetUI.ListValue>
                {columnValue}
              </ColumnFilterWidgetUI.ListValue>
            </ColumnFilterWidgetUI.ListItem>
          );
        })}
      </ColumnFilterWidgetUI.List>
      <ThinDivider layout="horizontal" size="full" />
    </ColumnFilterWidgetUI.Container>
  );
};

export default FilterValues;
